module.exports = __webpack_public_path__ + "static/media/Technologyicon04.89fde76a.png";